import React,{Component} from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Table, Card, ButtonGroup, Button } from 'reactstrap';

import capitalize from 'lodash/capitalize';

import SearchInput from '../SearchInput';

import { humanReadableList } from '../../utils';

import find from 'lodash/find';
import './index.css';

class SearchableDataTable extends Component {
  constructor(props){
    super(props);

    this.state = {
      isScrolledToBottom:false,
      sortColumnName:this.props.defaultSortColumn,
      sortColumnDescending:true,
      isLoaded:false,
      searchActive:false,
      searchParam:''
    };
  }

  componentWillMount(){
    const { columns, defaultSortFunc } = this.props;

    const firstColumnWithSort = find(columns, (col) => col.sortFunc);

    if(firstColumnWithSort && !firstColumnWithSort.name){
      throw new Error('Can not sort by a column without a name');
    }

    if(!defaultSortFunc && firstColumnWithSort){
      this.setState({sortColumnName:firstColumnWithSort.name});
    }
  }

  componentDidUpdate(prevProps) {
    // Typical usage (don't forget to compare props):
    if (this.props.items.length !== prevProps.items.length) {
      console.log(this.props.items)
    }
  }

  handleColumnSortClick(column){
    const previousSortColumnName = this.state.sortColumnName,
      previousSortColumnDescending = this.state.sortColumnDescending;

    if(!column.sortFunc){
      throw new Error('Can not sort by a column without a sortFunc');
    }

    if(column.sortFunc && !column.name){
      throw new Error('Can not sort by a column without a name');
    }

    if(previousSortColumnName === column.name){
      this.setState({sortColumnDescending:!previousSortColumnDescending});
    } else {
      this.setState({
        sortColumnName:column.name,
        sortColumnDescending:true
      });
    }
  }

  render(){
    const { columns, defaultSortFunc, onSearch, searchPromptText, emptyText, hideSearch, isActiveFunc, items, getFilterSection } = this.props;

    const { sortColumnName, sortColumnDescending, searchParam } = this.state;

    const sortColumn = find(columns, (col) => col.name === sortColumnName) || {sortFunc:null};

    const sortFunc = sortColumn.sortFunc || defaultSortFunc || ((a,b) => 1);

    const filterFunc = (item) => searchParam === '' || columns.some((col) => col.filterFunc ? col.filterFunc(item,searchParam) : false );

    const sortedFilteredItems = items.filter(filterFunc).sort(sortFunc);

    const finalItems = sortColumnDescending ? sortedFilteredItems : sortedFilteredItems.reverse();

    const searchableFields = columns.filter((col) => col.filterFunc).map((col) => col.display || col.name);

    const isSearchable = onSearch || columns.some((col) => col.filterFunc);

    const searchPlaceholder = searchPromptText || `Search by ${humanReadableList(searchableFields,'or')}`

    return (
      <div>
        {items.length > 0 && isSearchable && !hideSearch && (
          <Row>
            <Col xs='6'>
              <SearchInput
                placeholder={searchPlaceholder}
                debounce={onSearch ? 1000 : 0}
                onChange={(val) => this.setState({searchParam:val.toLowerCase()})}
              />
              <br />
            </Col>
          </Row>
        )}
        {getFilterSection()}
        {finalItems.length > 0 ? (
          <Card>
            <Table className='RoundedTable--root'>
              <colgroup>
                {columns.map((column,i) => (
                  <col
                    key={i}
                    style={{width:`${column.width || Math.round(100 / columns.length)}%`}}
                  />
                ))}
              </colgroup>
              <thead>
                <tr>
                  {columns.map((col,i) => (
                    <th
                      key={i}
                      onClick={col.sortFunc ? () => this.handleColumnSortClick(col) : () => {}}
                      style={{
                        cursor:col.sortFunc ? 'pointer' : 'default',
                        fontWeight:sortColumnName === col.name || sortColumnName === null? 'bold' : 'normal',
                        userSelect:'none',
                        overflow:'hidden',
                        textOverflow:'ellipsis',
                        borderTop:0
                      }}
                    >
                      {col.display || capitalize(col.name || '')}
                      {col.sortFunc && (
                        <span>
                          &nbsp;
                          <i
                            className={`fa fa-caret-${sortColumnName === col.name && !sortColumnDescending ? 'up' : 'down'}`}
                            aria-hidden="true"
                          ></i>
                        </span>
                      )}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {finalItems.map((item,i) => (
                  <tr key={i}>
                    {columns.map((col,j) => (
                      <td key={j} className={isActiveFunc(item) || col.alwaysActive ? '' : 'deactivated'}>
                        {col.renderCell(item)}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </Table>
          </Card>
        ) : (
          <Card style={{display: (items.length === 0 && emptyText === '') ? 'none' : 'inherit'}}>
            <div className='EmptyListPlaceholder'>
              {items.length > 0 ? `Nothing matches "${searchParam}"` : emptyText}
            </div>
          </Card>
        )}
      </div>
    )
  }
}

SearchableDataTable.propTypes = {
  items:PropTypes.arrayOf(PropTypes.object),
  defaultSortColumn:PropTypes.string,
  onSearch:PropTypes.func,
  onPage:PropTypes.func,
  defaultSortFunc:PropTypes.func,
  isActiveFunc:PropTypes.func,
  getFilterSection:PropTypes.func,
  searchPromptText:PropTypes.string,
  emptyText:PropTypes.string,
  hideSearch:PropTypes.bool,
  columns:PropTypes.arrayOf(PropTypes.shape({
    name:PropTypes.string,
    alwaysActive:PropTypes.bool,
    display:PropTypes.string,
    width:PropTypes.number,
    sortFunc:PropTypes.func,
    filterFunc:PropTypes.func,
    renderCell:PropTypes.func.isRequired,
  }))
}

SearchableDataTable.defaultProps = {
  onSearch:() => {},
  onPage:() => {},
  isActiveFunc:() => true,
  getFilterSection: () => {},
  defaultSortColumn: null,
  items:[]
}

export default SearchableDataTable;



// WEBPACK FOOTER //
// ./src/shared/components/SearchableDataTable/index.js